// First-touch marketing attribution.
//
// When someone lands from a tracked link (e.g. a newsletter sponsor read at
// alphagrade.io/?utm_source=dailyupside&utm_campaign=jun_test), capture the
// source ONCE and stash it. At signup we send it to the backend so each
// account records which channel drove it — making the paid-channel test
// measurable. First-touch (don't overwrite) so the original source survives
// later visits.

const KEY = 'ag_attribution';

export function captureAttribution() {
  try {
    if (localStorage.getItem(KEY)) return; // first-touch wins
    const params = new URLSearchParams(window.location.search);
    const source = params.get('utm_source') || params.get('ref');
    if (!source) return;
    const campaign = params.get('utm_campaign') || '';
    localStorage.setItem(
      KEY,
      JSON.stringify({
        source: source.slice(0, 80),
        campaign: campaign.slice(0, 80),
        at: new Date().toISOString(),
      })
    );
  } catch {
    // localStorage unavailable (private mode, etc.) — attribution is best-effort.
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null') || {};
  } catch {
    return {};
  }
}

// Visible self-test for the live UTM check — no DevTools needed. Land on any
// URL with &ag_debug=1 (e.g. /?utm_source=verify_test&ag_debug=1) and a bar
// appears: GREEN with the captured source = the UTM pipe works end-to-end;
// RED = no attribution captured (a redirect likely stripped the query param
// before the app loaded). Gated behind the flag, so normal visitors never see
// it. Safe to leave in; remove after the channel test if you like.
export function maybeShowAttributionDebug() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('ag_debug') !== '1') return;
    const append = () => {
      if (!document.body) return;
      const data = getAttribution();
      const ok = !!data.source;
      const bar = document.createElement('div');
      bar.textContent = ok
        ? `✓ attribution captured — source: ${data.source}  campaign: ${data.campaign || '(none)'}`
        : '✗ NO attribution captured — a redirect may have stripped ?utm_source before the app loaded';
      bar.style.cssText =
        'position:fixed;bottom:0;left:0;right:0;z-index:99999;padding:10px 14px;' +
        'font:13px/1.4 monospace;text-align:center;color:#fff;background:' +
        (ok ? '#065f46' : '#991b1b') + ';';
      document.body.appendChild(bar);
    };
    if (document.body) append();
    else document.addEventListener('DOMContentLoaded', append);
  } catch {
    // best-effort; never break the app for a debug aid.
  }
}
